import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_STUDENT_DATA_REQUEST_AUDIENCE_COUNT } from '@/graphql/studentDataRequests';
import type { StudentDataRequestAudienceInput } from '@/types/composition-functions';
import type {
  StudentDataRequestAudienceCountQuery, StudentDataRequestAudienceCountQueryVariables,
} from '@/types/operations';

/** How many students an audience would reach now, within what the sender may update. */
export function useStudentDataRequestAudienceCount(audience: Ref<StudentDataRequestAudienceInput | null>) {
  const { result, loading, error } = useQuery<StudentDataRequestAudienceCountQuery, StudentDataRequestAudienceCountQueryVariables>(
    GET_STUDENT_DATA_REQUEST_AUDIENCE_COUNT,
    () => ({ audience: audience.value ?? { all_students: false } }),
    () => ({ fetchPolicy: 'network-only', enabled: audience.value !== null }),
  );

  return {
    count: computed(() => (audience.value === null ? null : result.value?.studentDataRequestAudienceCount ?? null)),
    loading,
    error,
  };
}
